import {
  Filter,
  FilterContent,
  FilterTrigger,
  type FilterContentProps,
} from '@/components/shared/Filter';

import { useGetSupplementFilterQuery } from '@viome/viome-base/src/usecase/Nutrition/NutritionQuery';

export type MyIngredientsPageFilterSidebarProps = FilterContentProps;

export const MyIngredientsPageFilterSidebar = ({
  onSubmit,
  initialValue = {},
  productId,
}: MyIngredientsPageFilterSidebarProps) => {
  const { data: response, isLoading, isError } = useGetSupplementFilterQuery(productId);

  const filters = response?.[0]?.filter;

  return (
    <Filter>
      <FilterTrigger
        isError={isError}
        isLoading={isLoading}
        initialValue={initialValue}
      />

      <FilterContent
        filters={filters}
        isError={isError}
        onSubmit={onSubmit}
        isLoading={isLoading}
        initialValue={initialValue}
      />
    </Filter>
  );
};
